module.exports = __webpack_public_path__ + "img/ht.68255139.svg";